import React, {useState, useEffect, useContext} from 'react'
import { PDFViewer } from '@react-pdf/renderer';
import MyDocument from './MyDocument';

// Cmaterial Components
import { Button, Autocomplete, TextField, Dialog, DialogContent } from '@mui/material';

import { getWeeks } from '../../Utils/getWeeks';

// firebase context
import { FirebaseContext } from '../../Services/firebase'

export default function DocumentViewer(props) {

    const firebase = useContext(FirebaseContext)
    const [Weeks, setWeeks] = useState([]);
    const [Value, setValue] = useState('semaines');
    const [InputValue, setInputValue] = useState('');
    const [open, setOpen] = React.useState(false);
    const [Day1, setDay1] = useState([]);
    const [Day2, setDay2] = useState([]);
    const [Day3, setDay3] = useState([]);
    const [Day4, setDay4] = useState([]);
    const [Day5, setDay5] = useState([]);
    const [Day6, setDay6] = useState([]);
    const [Day7, setDay7] = useState([]);

    useEffect(() => {
        getWeeks(firebase, props.UserSession.uid, setWeeks);
    }, [firebase, props.UserSession.uid]);

    const getMenusInfos = () => {
        const getDayData = (day) => {
          firebase.getMenusDate(props.UserSession.uid, Value, day).get()
            .then(querySnapshot => {
              querySnapshot.docs.forEach(doc => {
                firebase.getMenusContent(props.UserSession.uid, Value, day, doc.id).get()
                  .then(doc => {
                    const mydata = doc.data();
                    console.log(mydata);
                    switch(day) {
                      case '1':
                        setDay1(mydata);
                        break;
                      case '2':
                        setDay2(mydata);
                        break;
                      case '3':
                        setDay3(mydata);
                        break;
                      case '4':
                        setDay4(mydata);
                        break;
                      case '5':
                        setDay5(mydata);
                        break;
                      case '6':
                        setDay6(mydata);
                        break;
                      case '7':
                        setDay7(mydata);
                        break;
                      default:
                        break;
                    }
                  });
              });
            });
        };
      
        // On appelle la fonction pour chaque jour
        for (let day = 1; day <= 7; day++) {
          getDayData(day.toString());
        }
      
        setOpen(true);
      };
    
    const handleClose = () => {
        setOpen(false);
    };
    
    return (
        <div style={{display: "flex", flexDirection: "row", marginBottom: "1vh"}}>
            <Autocomplete
                value={Value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                inputValue={InputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                disablePortal
                id="combo-box-demo"
                options={Weeks}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField {...params} label="clients" />}
            />
            <Button variant="outlined" style={{marginLeft: "0.5vw"}} onClick={getMenusInfos}>Afficher</Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={'lg'}
            >
                <DialogContent>
                    <PDFViewer style={{width: "90vw", height: "80vh"}}>
                        <MyDocument value={Value || []} day1={Day1 || []} day2={Day2 || []} day3={Day3 || []} day4={Day4 || []} day5={Day5 || []} day6={Day6 || []} day7={Day7 || []}/>
                    </PDFViewer>
                </DialogContent>
            </Dialog>
        </div>
    )
}